/** @jsxImportSource react */
import React from 'react';

export interface PauseIconProps {
  size?: number;
  className?: string;
}

export function PauseIcon({ size = 20, className }: PauseIconProps) {
  return React.createElement(
    'svg',
    {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'none',
      className,
      'aria-hidden': true,
    },
    React.createElement('rect', { x: '6', y: '4', width: '4', height: '16', rx: '1', fill: 'currentColor' }),
    React.createElement('rect', { x: '14', y: '4', width: '4', height: '16', rx: '1', fill: 'currentColor' }),
  );
}
